<template>
	<div class="content">
		<el-form :model="queryParams" ref="queryForm" :inline="true">
			<el-form-item prop="userId">
				<el-select v-model="queryParams.userId" filterable clearable placeholder="代理商" @change="search">
					<el-option v-for="(item,index) in agentList" :key="index" :label="'['+item.username+']-' + item.company"
						:value="item.userId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="iccid">
				<el-input v-model="queryParams.iccid" clearable placeholder="ICCID/ICCIDS空格隔开"></el-input>
			</el-form-item>
			<el-form-item prop="msisdn">
				<el-input v-model="queryParams.msisdn" clearable placeholder="MSISDN/MSISDNS空格隔开"></el-input>
			</el-form-item>
			<el-form-item prop="cardStatus">
				<el-select v-model="queryParams.cardStatus" filterable placeholder="运营状态" @change="search" clearable multiple>
					<el-option v-for="item in state" :key="item.cardStatus" :label="item.operationName"
						:value="item.cardStatus"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="showStatus">
				<el-select v-model="queryParams.showStatus" filterable placeholder="状态" @change="search" clearable multiple>
					<el-option v-for="item in state" :key="item.cardStatus" :label="item.operationName"
						:value="item.cardStatus"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="gprsStatus">
				<el-select v-model="queryParams.gprsStatus" placeholder="GPRS状态" @change="search" clearable>
					<el-option v-for="item in gprsList" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="cardType">
				<el-select v-model="queryParams.cardType" placeholder="请选择卡类型" multiple @change="search" clearable>
					<el-option v-for="item in cardTypeList" :key="item.id" :label="item.name" :value="item.name"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="startFlowRatio">
				<el-input v-model="queryParams.startFlowRatio" clearable placeholder="流量比例开始值"
					oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
					<svg-icon slot="prefix" icon-class="ge" style="font-size:18px;color:#515a6e" />
				</el-input>
			</el-form-item>
			<el-form-item prop="endFlowRatio">
				<el-input v-model="queryParams.endFlowRatio" clearable placeholder="流量比例结束值"
					oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
					<svg-icon slot="prefix" icon-class="le" style="font-size:18px;color:#515a6e" />
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
				<el-button type="primary" icon="el-icon-plus" @click="handleBatchImport"
					v-hasPermi="['card:cardRatio:batchs']">批量添加</el-button>
				<el-button type="primary" icon="el-icon-upload" @click="handleImport"
					v-hasPermi="['card:cardRatio:import']">EXCEL导入</el-button>
				<el-button type="primary" class="el-icon-download" @click="handleExport"
					v-hasPermi="['card:cardRatio:export']">导出</el-button>
				<el-button type="danger" icon="el-icon-delete" :disabled="multiple" @click="resetFlowRatio"
					v-hasPermi="['card:cardRatio:reset']">比例重置</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="tableData" ref="tableData" border @sort-change="tableSortChange"
			@selection-change="handleSelectionChange" v-loading="loading">
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column prop="agentName" label="代理商" align="center" width="260px"
				:show-overflow-tooltip="true"></el-table-column>
			<el-table-column prop="iccid" label="ICCID" sortable="custom" align="center" min-width="200px">
				<template slot-scope="{row}">
					<el-link type="success" :underline="false" @click='jumpButton(row.iccid)'>{{row.iccid}}</el-link>
				</template>
			</el-table-column>
			<el-table-column prop="msisdn" label="MSISDN" align="center" min-width="140px"></el-table-column>
			<el-table-column prop="gprsStatus" label="GPRS" align="center" width="100px">
				<template slot-scope="{row}">
					<span v-if="row.gprsStatus =='1'">已开启</span>
					<span v-else>未开启</span>
				</template>
			</el-table-column>
			<el-table-column prop="cardStatus" label="运营状态" align="center">
				<template slot-scope="{row}">
					<el-tag v-if="row.cardStatus =='已激活'">{{row.cardStatus}}</el-tag>
					<el-tag v-else-if="row.cardStatus =='库存'" type="success">{{row.cardStatus}}</el-tag>
					<el-tag v-else-if="row.cardStatus =='已停机'" type="danger">{{row.cardStatus}}</el-tag>
					<el-tag v-else-if="row.cardStatus =='待激活'" type="info">{{row.cardStatus}}</el-tag>
					<el-tag v-else type="warning">{{row.cardStatus}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="showStatus" label="展示状态" align="center">
				<template slot-scope="{row}">
					<el-tag v-if="row.showStatus =='已激活'">{{row.showStatus}}</el-tag>
					<el-tag v-else-if="row.showStatus =='库存'" type="success">{{row.showStatus}}</el-tag>
					<el-tag v-else-if="row.showStatus =='已停机'" type="danger">{{row.showStatus}}</el-tag>
					<el-tag v-else-if="row.showStatus =='待激活'" type="info">{{row.showStatus}}</el-tag>
					<el-tag v-else type="warning">{{row.showStatus}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="monthFlow" label="月流量" align="center" sortable="custom" width="100px"></el-table-column>
			<el-table-column prop="flowRatio" label="比例值(%)" align="center" width="180px">
				<template slot="header">
					<el-tooltip content="比例值上浮百分比" placement="top">
						<i class="el-icon-question"></i>
					</el-tooltip>
					比例值
				</template>
				<template slot-scope="scope">
					<el-input size="mini" autocomplete="off" placeholder="比例值" @blur="handleCardFlowRatio(scope.row)" v-model="scope.row.flowRatio" suffix-icon="el-icon-edit"
						oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
					</el-input>
				</template>
			</el-table-column>
			
			<el-table-column label="操作" align="center" min-width="100px" fixed="right">
				<template slot-scope="scope">
					<el-button size="mini" type="success" plain icon="el-icon-setting"
						@click="flowRatioDetail(scope.row.iccid)">详情</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total>0" :total="total" :page.sync="page" :limit.sync="pageSize" @pagination="initData" />
		<!-- 导入对话框 -->
		<el-dialog :title="upload.title" :visible.sync="upload.open" width="450px" append-to-body
			:close-on-click-modal="false">
			
			<el-upload ref="upload" :limit="1" accept=".xlsx, .xls" :headers="upload.headers"
				:action="upload.url" :disabled="upload.isUploading"
				:on-progress="handleFileUploadProgress" :on-success="handleFileSuccess" :on-error="handleUploadError"
				:auto-upload="false" drag>
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				<div class="el-upload__tip text-center" style="text-align: center;" slot="tip">
					<span>仅允许导入xls、xlsx格式文件。</span>
					<el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;"
						@click="importTemplate">下载模板</el-link>
				</div>
			</el-upload>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitFileForm">确 定</el-button>
				<el-button @click="upload.open = false">取 消</el-button>
			</div>
		</el-dialog>
		<!-- 批量添加弹出框 -->
		<el-dialog title="批量添加" :visible.sync="batchFormOpen" width="680px" append-to-body :close-on-click-modal="false">
			<el-form ref="batchForm" :model="batchForm" :rules="batchRuleForm" label-width="120px">
				<el-row>
					<el-col :span="24">
						<el-form-item prop="flowRatio">
							<span slot="label">
								<el-tooltip content="设置比例值，表示上浮百分比" placement="top">
									<i class="el-icon-question"></i>
								</el-tooltip>
								比例值
							</span>
							<el-input v-model="batchForm.flowRatio" clearable placeholder="请输入比例值"
								oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
								<template slot="append">%</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="字段类型" prop="fieldType">
							<el-radio v-model="batchForm.fieldType" label="1">ICCID</el-radio>
							<el-radio v-model="batchForm.fieldType" label="2">MSISDN</el-radio>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="卡号列表" prop="iccids">
							<el-input v-model="batchForm.iccids" type="textarea" clearable placeholder="请输入内容" rows="8"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="卡号范围">
					<el-row>
						<el-col :span="11">
							<el-form-item prop="iccidStart">
								<el-input v-model="batchForm.iccidStart" clearable placeholder="包含开始值"></el-input>
							</el-form-item>
						</el-col>
						<el-col style="text-align: center;" :span="2">-</el-col>
						<el-col :span="11">
							<el-form-item prop="iccidEnd">
								<el-input v-model="batchForm.iccidEnd" clearable placeholder="包含终止值"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitBatchForm" :loading="submitLoading">确 定</el-button>
				<el-button @click="cancelBatchForm">取 消</el-button>
			</div>
		</el-dialog>

		<!-- 批量添加弹出框 -->
		<el-dialog title="比例设置记录" :visible.sync="recordOpen" width="680px" append-to-body :close-on-click-modal="false">
			<el-table
			:data="recordData"
			border
			max-height="750"
			style="width: 100%">
				<el-table-column
					prop="iccid"
					label="ICCID"
					width="180"
					align="center">
				</el-table-column>
				<el-table-column
					prop="flowRatio"
					label="比例值"
					width="100"
					align="center">
				</el-table-column>
				<el-table-column
					prop="createTime"
					label="创建时间"
					width="220"
					align="center">
				</el-table-column>
				<el-table-column
					prop="username"
					label="操作人"
					align="center">
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
	import { agentList } from "@/api/api.js"; //获取代理商下拉列表
	import { cardRatioList, batchCardFlowRatio , resetCardFlowRatio , updateCardFlowRatio , cardFlowRatioRecord} from "@/api/api.js"; //列表
	import { exportCardFlowRatio } from "@/api/api.js"; //比例
	import { cardBaseInfo } from "@/api/api.js"; //卡类型
	import { getToken } from '@/utils/auth'
	export default {
		name: "controlCard",
		data() {
			return {
				//遮罩层
				loading: true,
				// 选中数组
				ids: [],
				// 非单个禁用
				single: true,
				// 非多个禁用
				multiple: true,
				queryParams: {

				},
				tableData: [],
				dateRange: [],
				folding: false,
				// 排序方式
				sortOrder: "",
				// 排序名称
				sortName: "",
				page: 1,
				pageSize: 10,
				total: 0,
				agentList: [],
				cardTypeList: [],
				// 状态
				state: [{
						cardStatus: "1",
						operationName: "库存"
					},
					{
						cardStatus: "2",
						operationName: "待激活"
					},
					{
						cardStatus: "3",
						operationName: "可测试"
					},
					{
						cardStatus: "4",
						operationName: "已激活"
					},
					{
						cardStatus: "5",
						operationName: "已停机"
					},
					{
						cardStatus: "6",
						operationName: "预销户"
					},
					{
						cardStatus: "7",
						operationName: "已销户"
					},
					{
						cardStatus: "8",
						operationName: "停机保号"
					},
					{
						cardStatus: "9",
						operationName: "已补卡"
					}
				],
				gprsList: [{
					value: '1',
					label: '已开启'
				}, {
					value: '0',
					label: '未开启'
				}],
				upload: {
					// 是否显示弹出层（用户导入）
					open: false,
					// 弹出层标题（用户导入）
					title: "",
					//上架1  下架 2
					flowRatioStatus: "1",
					// 是否禁用上传
					isUploading: false,
					// 设置上传的请求头部
					headers: { Authorization: getToken() },
					// 上传的地址
					url: process.env.VUE_APP_BASE_API + "/card/ratio/import",
				},
				dialog: false,
				batchForm: {},
				batchFormOpen: false,
				submitLoading: false,
				batchRuleForm: {
					flowRatio: [
						{ required: true, message: "比例值不能为空", trigger: "blur" },
					],
					fieldType: [
						{ required: true, message: "字段类型不能为空", trigger: "blur" },
					],
				},
				recordOpen:false,
				recordData:[]

			}
		},
		methods: {
			// 获取列表的数据
			initData() {
				let params = {
					model: {
						...this.addDateRange(this.queryParams, this.dateRange),
						order: this.sortOrder,
						sort: this.sortName,
					},

					page: this.page,
					pageSize: this.pageSize
				}
				this.loading = true;
				cardRatioList(params).then(res => {
					this.tableData = res.data.data.records;
					this.total = res.data.data.total;
					this.loading = false;
				})
			},
			tableSortChange(val) {
				this.sortOrder = val.order === "descending" ? "desc" : "asc";
				if (val.prop == 'monthFlow') {
					this.sortName = 'monthFlow'
				}
				if (val.prop == 'lastOpenTime') {
					this.sortName = 'lastOpenTime'
				}
				if (val.prop == 'lastRechargeTime') {
					this.sortName = 'lastRechargeTime'
				}
				if (val.prop == 'closeTime') {
					this.sortName = 'closeTime'
				}
				if (val.prop == 'iccid') {
					this.sortName = 'iccid'
				}
				this.initData()
			},
			// 搜索
			search() {
				this.page = 1
				this.initData()
			},
			// 重置
			resetQuery() {
				this.dateRange = [];
				this.sortOrder = '';
				this.sortName = '';
				this.$refs.tableData.clearSort();
				this.resetForm("queryForm");
				this.search();
			},
			cardBaseInfo() {
				cardBaseInfo().then(res => {
					this.cardTypeList = res.data.data.cardType;
				})
			},
            handleCardFlowRatio(row){
                if(!row.flowRatio){
                    this.initData()
                    return
                }
                let param={
                    id:row.id,
                    flowRatio:row.flowRatio
                }
                updateCardFlowRatio(param).then(res=>{
                    this.initData()
                })
            },
			resetFlowRatio() {
				const cardIds = this.ids;
				this.$confirm('是否确认将这些数据比例重置为0？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = JSON.stringify(cardIds);
					resetCardFlowRatio(params).then(res => {
						let msg = res.data.message;
						if (res.data.code == 200) {
							this.$message({
								type: 'success',
								message: '移除成功'
							});
							this.initData()
						} else {
							this.$message({
								type: 'waring',
								message: msg
							});
						}
					});

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消移除'
					});
				});
			},
			flowRatioDetail(iccid){
				cardFlowRatioRecord({iccid:iccid}).then(res=>{
					this.recordOpen = true
					this.recordData = res.data.data
				})
			},
			// 导出
			handleExport() {
				let params = {
					...this.addDateRange(this.queryParams, this.dateRange),
					order: this.sortOrder,
					sort: this.sortName,
				}
				exportCardFlowRatio(params).then(res => {
					this.$notify({
						title: "提示",
						message: "已提交导出，请在任务中心查看进度",
						type: "success",
						offset: 30
					});
				})
			},
			handleImport() {
				this.upload.title = "卡导入";
				this.upload.open = true;
			},
			/** 下载模板操作 */
			importTemplate() {
				this.download('/card/ratio/importTemplate', {}, `ratio_template_${new Date().getTime()}.xlsx`)
			},
			// 文件上传中处理
			handleFileUploadProgress(event, file, fileList) {
				this.upload.isUploading = true;
			},
			// 文件上传成功处理
			handleFileSuccess(response, file, fileList) {
				this.upload.open = false;
				this.upload.isUploading = false;
				this.$refs.upload.clearFiles();
				this.search();
			},
			handleUploadError() {
				this.$message.error("批量文件上传失败");
			},
			// 提交上传文件
			submitFileForm() {
				this.$refs.upload.submit();
			},
			//代理商下拉列表
			queryAgentList() {
				agentList().then(res => {
					this.agentList = res.data.data;
				});
			},
			// 多选单选的值
			handleSelectionChange(selection) {
				this.ids = selection.map(item => item.id);
				this.single = selection.length != 1;
				this.multiple = !selection.length;
			},
			handleBatchImport() {
				this.batchFormOpen = true;
			},
			submitBatchForm() {
				let { iccids } = this.batchForm;
				let params = {
					...this.batchForm,
					iccids: iccids ? iccids.split("\n") : []
				};
				this.$refs["batchForm"].validate(valid => {
					if (valid) {
						this.submitLoading = true;
						batchCardFlowRatio(params).then(res => {
							this.$notify.info({
								title: "提示",
								message: "批量卡操作已提交，请在任务中心查看进度",
								duration: 1000,
								offset: 30
							});
							this.submitLoading = false;
							this.cancelBatchForm();
							this.resetQuery();
						}).catch(() => {
							this.submitLoading = false;
						})
					}
				});
			},
			cancelBatchForm() {
				this.resetForm('batchForm');
				this.batchFormOpen = false;
			},
			// 关闭弹窗
			dialogClose() {
				this.$refs.beizhu.clearValidate();
				this.dialog = false;
			},
			// 弹窗的取消按钮
			cancelDialog() {
				this.dialog = false;
			},

			jumpButton(iccid) {
				this.$router.push({ path: "/card/detail", query: { iccid: iccid } });
			},
		},
		mounted() {

		},
		created() {
			this.cardBaseInfo();
			this.queryAgentList();
			this.initData()
		}
	};
</script>
<style scoped lang="less">
</style>